import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import configs from '@/config/defaultSettings'
import qs from 'qs'
import { ACCESS_TOKEN } from '@/store/mutation-types'
// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.NODE_ENV == 'development' ? '' : '', // api base_url
  timeout: 600000 // 请求超时时间
})


const IECCLUDELIST = ['/mcn/', '/egc/', '/egcms/']
const NOTIPS = ['/mcn/tips','/mcn/export']

const err = error => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: error.response.request.responseURL
      })
    } else if (error.response.status === 401) {
      notification.error({
        message: 'Unauthorized',
        description: error.response.request.responseURL
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    } else if (error.response.status === 404) {
      notification.error({
        message: '404',
        description: error.response.request.responseURL
      })
    } else {
      notification.error({
        message: '接口出问题啦',
        description: error.response.request.responseURL
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if (!config.url.includes('http://') && !config.url.includes('https://')) {
    if (process.env.NODE_ENV == 'production') {
      if (process.env.VUE_APP_PREVIEW == 'true') {
        //测试环境
        const base_url = location.host.indexOf('get88') != -1 ? configs.bztestUrl : configs.testUrl
        config.url = base_url + config.url
      } else {
        //正式环境
        const base_url = location.host.indexOf('get88') != -1 ? configs.bzproUrl : configs.proUrl
        config.url = base_url + config.url
      }
    } else {
      //测试环境
      const base_url = location.host.indexOf('get88') != -1 ? configs.bztestUrl : configs.testUrl
      config.url = base_url + config.url
    }
  }
  if (config.method == 'post') {
    // 历史版本的post的传输用的formData, 不清楚原因，需要用json传输加isJson
    const isFormData = config.data instanceof FormData
    if (!isFormData && !config.isJson) {
      var isStringify = true
      IECCLUDELIST.forEach(item => {
        if (config.url.indexOf(item) >= 0) {
          isStringify = false
        }
      })
      if (isStringify) {
        config.data = qs.stringify(config.data)
      }
    }
  }
  // 头里面增加一个二级菜单的参数secondary-menu，便于操作日志 breadcrumb ：全路径标题 pageTitle ：当前页标题
  config.headers['secondary-menu'] = encodeURIComponent(localStorage.getItem('breadcrumb'))
  config.headers['func'] = encodeURIComponent(config.func)
  return config
}, err)

// response interceptor
service.interceptors.response.use(response => {

  var isTips = true
  NOTIPS.forEach(item => {
    if (response.config.url.indexOf(item) >= 0) {
      isTips = false
    }
  })
  if (!isTips) {
    return response.data
  }

  if (response.data.code == -2) {
    store.dispatch('Logout').then(() => {
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    })
  } else if (response.data.code == -3) {
    notification.error({
      message: '您的账号已在其他地方登录，请确认是否本人操作，如非本人操作，请及时更改密码'
    })
    store.dispatch('Logout').then(() => {
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    })
  } else if (response.data.code != 1) {
    notification.error({
      message: response.data.message
    })
  } else if (response.data.code === undefined) {
    notification.error({
      message: response.data.message
    })
    return { code: -100 }
  }
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export { installer as VueAxios, service as axios }
